import React, { useState, useEffect, useRef } from "react";

function ADDCheckbox(props) {
  const {
    label,
    name,
    id,
    fieldId,
    isRequired,
    errId,
    divClass,
    options,
    checkDetailsIndex,
    fieldName,
    handleCheckboxChange,
    fieldValue,
  } = props;

  const handleOnChange = (e) => {
    handleCheckboxChange(e.target);
  };
  return (
    <>
      <div className="col-sm-4 col-md-12 col-xl-4">
        <div className="form-group">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              name={name}
              id={id}
              onChange={(e) => handleOnChange(e)}
              data-checkdetailsindex={checkDetailsIndex}
              data-fieldname={fieldName}
              checked={fieldValue == "1" ? true : false}
            />
            <label htmlFor={name} className="form-check-label">
              {label}
            </label>
          </div>
        </div>
      </div>
    </>
  );
}

export default ADDCheckbox;
